import React from "react";
import { Spinner } from "react-bootstrap";

const IsLoading = () => {
  return (
    <Spinner animation="border" variant="bg_primary" className="text_primary d-block mx-auto my-4" />
  );
};

export default IsLoading;
